import React from "react";
import {message, Skeleton} from "antd";
import ServiceCaseForm from "../../../component/service-case-form";
import {addServiceCase, getServiceCaseDetail, updateServiceCase} from "../../../action/service_case_action";

class CaseDetail extends React.Component{

    static STATE_STRUCT = () => {
        return {
            uploadLoading: false,
            loading: false,
            formDefaultValue: null,
        }
    };

    state = CaseDetail.STATE_STRUCT();

    componentDidMount() {
        if (this.props.match.params.id){
            this._getData(this.props.match.params.id);
        }
    }

    _getData = (id) => {
        this.setState({loading: true});
        getServiceCaseDetail(id, (res, msg) => {
            if (res){
                this.setState({formDefaultValue: res});
            }else{
                message.error(msg ? msg : "获取例子详情失败");
                this.props.history.push("/case");
            }
        });
    };

    _createForm = () =>
        (<ServiceCaseForm defaultFormValue={this.state.formDefaultValue} onUpload={(values)=>{
            this.setState({uploadLoading: true});
            if(this.props.match.params.id){
                values.id = this.props.match.params.id;
                updateServiceCase(values, (res, msg) => {
                    this.setState({uploadLoading: false});
                    if (res){
                        this.props.history.push("/case");
                    }else
                        message.error(msg ? msg : "更新例子失败");
                })
            }else{
                addServiceCase(values, (res, msg) => {
                    this.setState({uploadLoading: false});
                    if (res){
                        this.props.history.push("/case");
                    }else
                        message.error(msg ? msg : "添加例子失败");
                });
            }
        }} loading={this.state.uploadLoading} />);

    render() {
        return (
            <Skeleton loading={this.props.loading}>
                <div>
                    <span style={{fontSize: 30, fontWeight: 500, color: "black", lineHeight: "70px"}}>
                        {
                            this.props.match.params.id ? '更新例子' : '添加例子'
                        }
                    </span>
                    {
                        this.props.match.params.id ? (this.state.formDefaultValue ? this._createForm() : <br/>) : this._createForm()
                    }
                </div>
            </Skeleton>
        );
    }
}

export default CaseDetail;
